<template>
  <div class="terms-conditions">
    <cms-content type="2"/>
  </div>
</template>

<script>
  import CmsContent from '@/components/layout/CmsContent.vue'
  export default {
    components: {
      CmsContent
    }
  }
</script>
